module.exports = __webpack_public_path__ + "static/media/Akash.da25cf80.png";